import { isBulkSelectOption } from "./workforce_member_select/workforce_member_select";

export const checkIsGroupBooking = (selectedUser: any, isGrouped: boolean = false) => {
  const isBulkSelect = selectedUser ? !isBulkSelectOption(selectedUser) : false;
  const isGroupBooking = isGrouped;

  return isGroupBooking || isBulkSelect;
};
